import { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import ApiService from "../apiService/ApiService";
import TextField from "@mui/material/TextField";

function DIDProviders(props) {
    const [open, setOpen] = useState(false);
    const [didProviders, setDidProviders] = useState([]);
    const [selectedDidProvider, setSelectedDidProvider] = useState(null);
    const [inputValue, setInputValue] = useState("");

    const handleSelectedDidProvider = (location) => {
        setSelectedDidProvider(location);
        props.setSelectedDidProvider(location);
    }

    const filterOptions = (options, { inputValue }) => {
        const inputValueLowerCase = inputValue.toLowerCase();

        return options.filter((option) => {
            return option.name.toLowerCase().startsWith(inputValueLowerCase);
        });
    };


    useEffect(() => {
        ApiService.get("api/v1/auth/did-providers/")
          .then((response) => {
            setDidProviders(response.data);
          })
          .catch((error) => {
            console.error("Error fetching Did Providers: ", error);
          });
    }, []);

    return (
        <Autocomplete
            id="combo-box"
            open={open && selectedDidProvider === null}
            onInputChange={(_, value) => {
            setInputValue(value);
            setOpen(value.length > 0);
            }}
            onClose={() => setOpen(false)}
            sx={{ width: "100%" }}
            value={selectedDidProvider}
            onChange={(event, newValue) => {
            handleSelectedDidProvider(newValue);
            setOpen(false);
            }}
            options={didProviders}
            getOptionLabel={(option) => option.name}
            filterOptions={filterOptions}
            renderOption={(props, option) => (
            <div {...props}>
                {option.name}
            </div>
            )}
            renderInput={(params) => (
              <TextField
              {...params}
              placeholder="Search"
              variant="outlined"
              size="small"
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "#34cb65", // Green border on hover
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#34cb65", // Green border on focus
                  },
                },
                "& .MuiInputBase-input": {
                  color: "#000", // Black text color
                },
              }}
            />
            )}
        />
    )
}

export default DIDProviders;